import React from 'react'

const PageSekeleton = () => {
  return (
    <div className='flex justify-center items-center text-black'>
        Waiting......
    </div>
  )
}

export default PageSekeleton